/**
 * Loads a `ResizeObserver` polyfill only on browsers without one. Our own call
 * sites feature-detect, but `react-modal-sheet` throws at render without it.
 */
export const loadResizeObserverPolyfill = async (): Promise<void> => {
  if (typeof window === 'undefined' || typeof ResizeObserver !== 'undefined') {
    return
  }

  const {default: ResizeObserverPolyfill} = await import(
    /* webpackChunkName: "resize-observer-polyfill" */
    'resize-observer-polyfill'
  )

  window.ResizeObserver =
    ResizeObserverPolyfill as unknown as typeof ResizeObserver
}
